import { sha256 } from 'js-sha256';

export default function Hash(objectToHash: any): string {
    return sha256(JSON.stringify(objectToHash)).toString();
}
